import { enUS } from "@clerk/localizations/en-US";
import { esES } from "@clerk/localizations/es-ES";
import { frFR } from "@clerk/localizations/fr-FR";
import { jaJP } from "@clerk/localizations/ja-JP";
import { resolveSupportedLocale, type SupportedLocale } from "./locale";

const clerkLocalizationByLocale: Record<SupportedLocale, typeof enUS> = {
  en: enUS,
  fr: frFR,
  ja: jaJP,
  es: esES,
};

export function getClerkLocalization(locale: string | null | undefined) {
  return clerkLocalizationByLocale[resolveSupportedLocale(locale)];
}
